<template>
	<form @submit.prevent="formSubmit" :class="{'form-submitting':form_submitting}" v-if="service" >
		<h1>Confirm this service has been deactivated</h1>
        
        <div class="normal field">
            <table class="basic">
                <tr>
                    <th>Service</th>
                    <td v-if="loading_service" ><span class="loading_string"></span></td>
                    <td v-else ><router-link :to="{name:'Service',params:{service_id:service.id}}" target="_blank">{{ service.id }}</router-link></td>
                </tr>
                <tr>
                    <th>Product</th>
                    <td v-if="loading_product" ><span class="loading_string"></span></td>
                    <td v-else ><router-link :to="{name:'Product',params:{product_id:product.id}}" target="_blank">{{ product.name }}</router-link></td>
                </tr>
                <tr>
                    <th>Location</th>
                    <td v-if="loading_location" ><span class="loading_string"></span></td>
                    <td v-else ><router-link :to="{name:'Location',params:{location_id:location.id}}" target="_blank">{{ location.full_name }}</router-link></td>
                </tr>
            </table>
		</div>



        <div class="normal field">
			<label>Assets </label>

            <table class="basic">
                <tr v-for="asset in assets" >
                    <td>
                        <b style="display:block;">
                            <router-link target="_blank" :to="{name:'Asset',params:{asset_id:asset.id}}">{{ asset.asset_type.name }}</router-link>
                        </b>
                        <p class="microheading">Serial number</p>
                        {{ asset.serial_number }}

                        <p class="microheading">MAC address</p>
                        {{ asset.mac_address }}
                    </td>
                </tr>
            </table>
            <div >
                
            </div>

		</div>
        
        <FormErrors v-if="form_errors.length" :errors="form_errors" />

        <div class="normal form_footer">
            <button class="btn-a" >Service has been stopped</button>
        </div>

	</form>

</template>


<script>

	import { ref } from "vue";

	import useFormUtil from "../../utils/FormUtil";
	import LoadingString from "../../components/LoadingString";
	import Sayt from "../../components/Sayt";
	import FieldErrors from "../../components/FieldErrors";
	import FormErrors from "../../components/FormErrors";
	import useActiveProviderStore from "../../stores/ActiveProviderStore";

	export default {
		
		props:['action'],

		components:{
			Sayt,
			LoadingString,
			FieldErrors,
			FormErrors,
		},

		setup() {
			
			const {provider} = useActiveProviderStore();
			
			// Form vals

			// States
			const form_submitting = ref(false);

			// Methods
			var {field_errors,form_errors,clearErrors,parseErrorResponse} = useFormUtil();

			return {
				provider,

				service : ref(null),
				loading_service : ref(true),

				location : ref(null),
				loading_location : ref(true),

				product : ref(null),
				loading_product : ref(true),

				asset : ref(null),
				loading_asset : ref(true),

				assets : ref([]),
				loading_assets : ref(true),

				asset_id : ref(null),
				
                form_submitting,
				field_errors,
				form_errors,
				clearErrors,
				parseErrorResponse,
			};
		},

		beforeMount(){
			this.init();
		},
        
		methods:{

			init(){
				this.loading_service = true;
				axios.get('services/'+this.action.params.service_id).then(({data})=>{
					this.service = data.data;
					this.loading_service = false;

                    if(this.service.location_id){
                        this.loading_location = true;
                        axios.get('locations/'+this.service.location_id).then(({data})=>{
                            this.location = data.data;
                            this.loading_location = false;
                        });

                        this.loading_product = true;
                        axios.get('products/'+this.service.product_id).then(({data})=>{
                            this.product = data.data;
                            this.loading_product = false;
                        });

                        this.loading_assets = true;
                        axios.get('assets?asset_class=CPE_ROUTER&service_id='+this.service.id).then(({data})=>{
                            this.assets = data.data;
                            this.loading_assets = false;
                        });
                    }
				});
			},

			formSubmit(){

                if(this.form_submitting) return;
                this.form_submitting = true;

				axios({
					url : 'services/'+this.action.params.service_id+'/mark-stopped',
					method : 'POST',
					data : {
					},
				}).then(({data})=>{
                    this.$emit('success',[data]);
				}).catch(this.parseErrorResponse).then(()=>{
					this.form_submitting = false;
				});

			},

		}
	}
</script>